import request from '@/utils/request';

// 注册接口
export function APIRegister(data) {
  return request({
    url: '/api/register',
    method: 'post',
    data
  });
}

// 登录接口
export function APILogin(data) {
  return request({
    url: '/api/login',
    method: 'post',
    data
  });
}

export function APICreateOrder(data) {
  return request({
    url: '/api/pay/createOrder',
    method: 'post',
    data
  });
}

export function APIAlipay(data) {
  return request({
    url: '/api/pay/payment',
    method: 'post',
    responseType: 'blob',
    data
  });
}